import ZLead from './ZLead.vue'
export default ZLead
